import React, { useEffect, useRef, useState } from 'react'
import { FaDotCircle, FaQuestionCircle } from 'react-icons/fa';
import { FaBaseball, FaCheck, FaCircleInfo, FaLeftRight, FaMinus, FaPlus, FaQuestion } from 'react-icons/fa6'
import { GiCricketBat, GiHorseHead } from 'react-icons/gi'
import { GoDotFill } from "react-icons/go";
import { IoMdClose } from "react-icons/io";
import RightSidebar from '../Component/Header/RightSidebar';
import { BiFootball } from 'react-icons/bi';
import { LiaTableTennisSolid } from 'react-icons/lia';
import { RiGovernmentFill } from 'react-icons/ri';
import { MdOutlineLiveTv, MdOutlineSportsKabaddi } from 'react-icons/md';
import { Link } from 'react-router-dom';

const InPlay = () => {
  const [activeTab, setActiveTab] = useState('Cricket');

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  // -----------------blue--------------------
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  // -----------------red--------------------
  const [isDropdownOpenRed, setIsDropdownOpenRed] = useState(false);

  const toggleDropdownRed = () => {
    setIsDropdownOpenRed(!isDropdownOpenRed);
  };

  // --------------------popup-------------------
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };
  return (

    <div className='flex'>
      <div className='max-h-screen overflow-y-scroll  w-[100%] lg:w-[70%]'>
        <div>

          {/* ---------------tab------------------- */}
          <div>
            <div className="mb-4 dark:border-gray-700 mx-2 md:mx-0">
              <ul className="flex items-center overflow-y-hidden -mb-px text-sm font-medium text-center pb-2 md:pb-0" id="default-tab" role="tablist">
                <li
                  className={`text-white py-1.5 rounded-md w-full text-sm text-center mx-1 ml-0 cursor-pointer  font-semibold bg-[#22262a] ${activeTab === 'Cricket' ? 'bg-white text-black' : ''}`}
                  role="presentation"

                  id="Cricket-tab"
                  onClick={() => handleTabClick('Cricket')}
                  aria-controls="Cricket"
                  aria-selected={activeTab === 'Cricket'}
                >
                  <button
                    className={`relative text-xs text-center w-20 lg:w-[4.6rem] ${activeTab === 'Cricket' ? 'bg-white text-black' : ''}`}
                  >
                    <span className='flex justify-center mb-1 text-lg '><GiCricketBat /></span>
                    Cricket
                    <span className={`   px-1.5 py-0 rounded top-0 right-0.5 absolute z-10 text-xs bg-white text-black ${activeTab === 'Cricket' ? 'bg-transparent text-white' : ''}`}>3</span>
                  </button>
                </li>

                <li
                  className={`text-white py-1.5 rounded-md w-full text-sm text-center mx-1 cursor-pointer  font-semibold bg-[#22262a] ${activeTab === 'Football' ? 'bg-white text-black' : ''}`}
                  role="presentation"

                  id="Football-tab"
                  onClick={() => handleTabClick('Football')}
                  aria-controls="Football"
                  aria-selected={activeTab === 'Football'}
                >
                  <button
                    className={`relative text-xs text-center w-20 lg:w-[4.6rem] ${activeTab === 'Football' ? 'bg-white text-black' : ''}`}
                  >
                    <span className='flex justify-center mb-1 text-lg '><BiFootball /></span>
                    Football
                    <span className={`   px-1.5 py-0 rounded top-0 right-0.5 absolute z-10 text-xs bg-white text-black ${activeTab === 'Football' ? 'bg-transparent text-white' : ''}`}>3</span>
                  </button>
                </li>

                <li
                  className={`text-white py-1.5 rounded-md w-full text-sm text-center mx-1 cursor-pointer  font-semibold bg-[#22262a] ${activeTab === 'Teniss' ? 'bg-white text-black' : ''}`}
                  role="presentation"

                  id="Teniss-tab"
                  onClick={() => handleTabClick('Teniss')}
                  aria-controls="Teniss"
                  aria-selected={activeTab === 'Teniss'}
                >
                  <button
                    className={`relative text-xs text-center w-20 lg:w-[4.6rem] ${activeTab === 'Teniss' ? 'bg-white text-black' : ''}`}
                  >
                    <span className='flex justify-center mb-1 text-lg '><LiaTableTennisSolid /></span>
                    Teniss
                  </button>
                </li>

                <li
                  className={`text-white py-1.5 rounded-md w-full text-sm text-center mx-1 cursor-pointer  font-semibold bg-[#22262a] ${activeTab === 'HorceRacing' ? 'bg-white text-black' : ''}`}
                  role="presentation"

                  id="HorceRacing-tab"
                  onClick={() => handleTabClick('HorceRacing')}
                  aria-controls="HorceRacing"
                  aria-selected={activeTab === 'HorceRacing'}
                >
                  <button
                    className={`relative text-xs text-center w-20 lg:w-[4.6rem] ${activeTab === 'HorceRacing' ? 'bg-white text-black' : ''}`}
                  >
                    <span className='flex justify-center mb-1 text-lg '><GiHorseHead /></span>
                    HorceRacing
                  </button>
                </li>

                <li
                  className={`text-white py-1.5 rounded-md w-full text-sm text-center mx-1 cursor-pointer  font-semibold bg-[#22262a] ${activeTab === 'Specialbets' ? 'bg-white text-black' : ''}`}
                  role="presentation"

                  id="Specialbets-tab"
                  onClick={() => handleTabClick('Specialbets')}
                  aria-controls="Specialbets"
                  aria-selected={activeTab === 'Specialbets'}
                >
                  <button
                    className={`relative text-xs text-center w-20 lg:w-[4.6rem] ${activeTab === 'Specialbets' ? 'bg-white text-black' : ''}`}
                  >
                    <span className='flex justify-center mb-1 text-lg '><BiFootball /></span>
                    Special bets
                  </button>
                </li>

                <li
                  className={`text-white py-1.5 rounded-md w-full text-sm text-center mx-1 cursor-pointer  font-semibold bg-[#22262a] ${activeTab === 'Greyhound' ? 'bg-white text-black' : ''}`}
                  role="presentation"

                  id="Greyhound-tab"
                  onClick={() => handleTabClick('Greyhound')}
                  aria-controls="Greyhound"
                  aria-selected={activeTab === 'Greyhound'}
                >
                  <button
                    className={`relative text-xs text-center w-20 lg:w-[4.6rem] ${activeTab === 'Greyhound' ? 'bg-white text-black' : ''}`}
                  >
                    <span className='flex justify-center mb-1 text-lg '><RiGovernmentFill /></span>
                    Greyhound
                  </button>
                </li>

                <li
                  className={`text-white py-1.5 rounded-md w-full text-sm text-center mx-1 cursor-pointer  font-semibold bg-[#22262a] ${activeTab === 'Politics' ? 'bg-white text-black' : ''}`}
                  role="presentation"

                  id="Politics-tab"
                  onClick={() => handleTabClick('Politics')}
                  aria-controls="Politics"
                  aria-selected={activeTab === 'Politics'}
                >
                  <button
                    className={`relative text-xs text-center w-20 lg:w-[4.6rem] ${activeTab === 'Politics' ? 'bg-white text-black' : ''}`}
                  >
                    <span className='flex justify-center mb-1 text-lg '><RiGovernmentFill /></span>
                    Politics
                  </button>
                </li>

                <li
                  className={`text-white py-1.5 rounded-md w-full text-sm text-center mr-0 mx-1 cursor-pointer  font-semibold bg-[#22262a] ${activeTab === 'Kabaddi' ? 'bg-white text-black' : ''}`}
                  role="presentation"

                  id="Kabaddi-tab"
                  onClick={() => handleTabClick('Kabaddi')}
                  aria-controls="Kabaddi"
                  aria-selected={activeTab === 'Kabaddi'}
                >
                  <button
                    className={`relative text-xs text-center w-20 lg:w-[4.6rem] ${activeTab === 'Kabaddi' ? 'bg-white text-black' : ''}`}
                  >
                    <span className='flex justify-center mb-1 text-lg '><MdOutlineSportsKabaddi /></span>
                    Kabaddi
                  </button>
                </li>


                {/* Add similar li elements for other tabs */}
              </ul>
            </div>
            <div id="default-tab-content">
              {/* ---------------1---------------- */}
              <div className={` ${activeTab === 'Cricket' ? 'block min-h-screen' : 'hidden'}`} id="Cricket" role="tabpanel" aria-labelledby="Cricket-tab">
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>In Play <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>Cricket <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>Cricket <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>Cricket <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>


              </div>

              {/* -------------------------------2-------------------------------- */}
              <div className={` ${activeTab === 'Football' ? 'block min-h-screen' : 'hidden'}`} id="Football" role="tabpanel" aria-labelledby="Football">
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>Football <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
              </div>
              <div className={` ${activeTab === 'Teniss' ? 'block min-h-screen' : 'hidden'}`} id="Teniss" role="tabpanel" aria-labelledby="Teniss">
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>Teniss <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
              </div>
              <div className={` ${activeTab === 'HorceRacing' ? 'block min-h-screen' : 'hidden'}`} id="HorceRacing" role="tabpanel" aria-labelledby="HorceRacing">
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>HorceRacing <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
              </div>
              <div className={` ${activeTab === 'Specialbets' ? 'block min-h-screen' : 'hidden'}`} id="Specialbets" role="tabpanel" aria-labelledby="Specialbets">
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>Specialbets <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
              </div>
              <div className={` ${activeTab === 'Greyhound' ? 'block min-h-screen' : 'hidden'}`} id="Greyhound" role="tabpanel" aria-labelledby="Greyhound">
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>Greyhound <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
              </div>
              <div className={` ${activeTab === 'Politics' ? 'block min-h-screen' : 'hidden'}`} id="Politics" role="tabpanel" aria-labelledby="Politics">
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>Politics <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
              </div>
              <div className={` ${activeTab === 'Kabaddi' ? 'block min-h-screen' : 'hidden'}`} id="Kabaddi" role="tabpanel" aria-labelledby="Kabaddi">
                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                  <div className='flex items-center p-2'>
                    <p className='flex items-center'>Kabaddi <GoDotFill className='text-[#169c59]' /></p>

                    <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                  </div>
                  <Link to={'/event'} className='lg:flex items-center theme-color justify-between px-3 py-1 lg:py-2 gap-2 border-b border-stone-950  block'>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='flex items-center w-full justify-between gap-1'>
                        <div className='flex items-center justify-between md:w-2/3 '>
                          <div className='flex items-center'>
                            <span className='px-2 py-2 bg-white rounded-full'><img className=' w-4' src='../../images/icon/Cricket.png' alt='' /></span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Delhi Capitals</span>
                              <span className='block text-xs text-gray-200'>Mumbai Indians</span>
                            </div>
                          </div>
                        </div>
                        <div className='flex items-center justify-between md:w-1/3'>
                          <div className='flex items-center'>
                            <span className='bg-green-700  px-1 font-small text-white uppercase leading-3 rounded-sm'>Live</span>
                            <div className='ms-4'>
                              <span className='block text-xs text-gray-200'>Today 19:30</span>
                              <div className='flex items-center justify-end w-full'>
                                <span className='text-green-300'><MdOutlineLiveTv /></span>
                                <span className='ml-3 bg-white text-black py-0 leading-3 px-1 font-small rounded-sm mt-1'>
                                  F
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex items-center justify-between w-full  py-2 md:py-0 md:w-1/2'>
                      <div className='grid grid-cols-6 w-full gap-1'>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>1.11</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>1.12</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>-</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold back-text'>12.00</div>
                        <div className='bg-[#32383e] text-xs text-gray-200 px-2 py-2 rounded-md text-center font-bold lay-text'>13.05</div>
                      </div>
                    </div>
                  </Link>

                </div>
              </div>


            </div>
          </div>
        </div>

        {isPopupOpen && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center mb-1 text-lg items-center">
            <div className=" bg-black p-4 rounded-md shadow-lg max-w-screen-lg overflow-y-auto">
              <div className='flex items-center border-b pb-2'>Rules <IoMdClose onClick={closePopup} className='ml-auto cursor-pointer' /></div>
              {/* Popup content */}
              <h2 className='pt-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo quae voluptas, doloremque ex excepturi esse ipsa at nemo sunt hic vel quidem ullam placeat, similique incidunt cupiditate maiores repellat aliquam deleniti aperiam! Earum, amet? Accusantium et minus suscipit consectetur rerum similique, obcaecati eum culpa? Possimus sapiente dicta nesciunt aperiam temporibus error minima voluptate mollitia optio. Animi aliquam voluptate cumque dignissimos mollitia repellat, rem repudiandae, ab sequi adipisci, perspiciatis velit error dolor nemo officia! Corrupti accusantium ipsa magni, consequatur blanditiis aspernatur magnam. Ipsum quod quos consequatur necessitatibus delectus officia dolor molestiae iure illo ipsam nulla eum at, totam iusto quasi eligendi! Sint debitis nisi veniam tempore tempora accusamus pariatur inventore, laudantium suscipit perferendis praesentium quam autem est quos aperiam et quidem dolorem, eaque repellendus! Laborum tenetur aut possimus eveniet quod repellendus, fugit eligendi veritatis, sunt quisquam sint commodi incidunt ea vitae autem voluptates totam. Cumque veritatis nihil quasi eos? Ad quaerat exercitationem soluta architecto ipsam facere voluptate delectus nostrum officia distinctio repellat sint atque optio deleniti id ipsum, numquam cumque facilis quidem at ex molestias a quod! Quaerat fugit nisi, maxime quis eos, perferendis in similique accusamus laboriosam id, optio sed quae hic aut doloremque numquam atque! Similique veritatis atque, est dolores molestias impedit minus officiis distinctio consectetur in et perferendis quia? Libero culpa nemo quisquam, eveniet placeat consequatur porro quasi aut iste, aspernatur quo magni. Minima rem amet nisi ullam numquam ipsum neque vitae asperiores. Tempora ex rerum, corporis nemo animi impedit alias deserunt magnam? Blanditiis reprehenderit repudiandae tempore atque aliquam nobis ab magni eaque explicabo nesciunt, perspiciatis laboriosam a cum iure beatae voluptatum cupiditate. Cupiditate distinctio laborum suscipit at exercitationem ea unde et aperiam. Magnam at assumenda et voluptatibus ad, molestias similique dolor rem praesentium quidem non natus molestiae in. Aliquam quam, omnis quibusdam animi accusantium ex nobis deserunt necessitatibus laborum sapiente explicabo dolor voluptas. Dolor eum perspiciatis est velit quia distinctio maiores aliquid quaerat veritatis voluptatum a consectetur quam optio cupiditate odit eos, nesciunt dignissimos labore culpa repellat? Sed officia obcaecati, cumque illum ducimus tempore ipsa rerum molestiae tempora enim odit, ut laudantium dolorum autem! Deleniti velit earum fugiat vero reiciendis neque nemo! Alias et ducimus voluptatem necessitatibus reiciendis! Minima perspiciatis vitae nihil recusandae possimus, quisquam fugit eos accusamus rem voluptatem quibusdam accusantium ducimus ut eveniet et nesciunt omnis praesentium? Harum adipisci assumenda, molestias provident ratione voluptatum id quaerat rerum quia aliquid magni, nostrum corrupti iure unde esse, excepturi animi! Officiis vitae, sunt voluptatum corrupti labore asperiores quod impedit accusantium in veritatis culpa dignissimos maxime quibusdam aliquam tenetur, ducimus recusandae! Eaque culpa minus voluptatibus placeat accusamus laudantium, molestiae voluptas voluptates obcaecati hic maxime. Veniam, unde praesentium, veritatis quis facere vel earum quisquam impedit iusto error placeat, illo laborum! Debitis iste harum eaque rerum provident, assumenda atque modi voluptatibus molestias sit obcaecati, quod ipsam? Reprehenderit, fuga suscipit fugiat accusantium accusamus numquam esse rerum quos eaque perferendis voluptate delectus aperiam iure inventore sequi nemo quisquam. Doloribus necessitatibus eveniet error, natus saepe sequi velit. Placeat id impedit laudantium odio necessitatibus fugit?</h2>

            </div>
          </div>
        )}
      </div>
      <div className='w-[30%] hidden lg:block ml-3'>
        <RightSidebar />
      </div>
    </div>
  )
}

export default InPlay